import InlineSlider from './inlineSlider';

const options = {
    navigation: {
        prevEl: '.js-inline-slider-arrows-previous',
        nextEl: '.js-inline-slider-arrows-next',
        disabledClass: 'inline-slider-arrows__arrow--disabled',
    },
    slideActiveClass: 'innovation-slider-item--active',
    spaceBetween: 24,
    watchOverflow: true,
    centeredSlides: true,
    slidesPerView: 1.2,
    loop: true,
    pagination: {
        el: '.js-innovation-pagination',
        type: 'bullets',
        renderBullet: (index, className) => `<span class="${className}"></span>`,
        bulletClass: 'slider-pagination__bullet',
        bulletActiveClass: 'slider-pagination__bullet--active',
        clickable: true,
    },
    breakpoints: {
        768: {
            centeredSlides: true,
            centeredSlidesBounds: false,
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 48,
        },
        1024: {
            centeredSlides: true,
            centeredSlidesBounds: false,
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 48,
        },
    },
};

const slider = {
    init() {
        const elements = [...document.querySelectorAll('.js-innovation-slider')];
        elements.forEach((element) => {
            // eslint-disable-next-line no-new
            new InlineSlider(element, options, '#innovation-slider-arrows');
        });
    },
};

export default slider;
